import { Component } from 'react';
import { Container, Col, Row, Button } from 'react-bootstrap'
import { connect } from "react-redux";

import { envelopeIconBlack, mobileIcon } from "../../img/font_awesome/font_awesome"
import { LOADING_STATUES } from "../constants/constants";
import translations from "../../config/translation/home_translations.json"

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer,
    language: state.languageReducer ? state.languageReducer : 'ENGLISH'
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    handleLockout: (lockout) => dispatch({ type: 'SET_LOCKOUT_IN_PLACE', lockout })
  }
}

class AlertHistoryViewRow extends Component {

  state = {
    selectedId: '',
    showMoreInfo: false,
    selectedAlertName: '',
    loadingStatus: ""
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  handleShowMoreInfo = (event) => {
    event.preventDefault();
    this.setState({ showMoreInfo: true })   
  }

  render() {
    return (
      <>
        <Container>
          <hr />
          <Row>
            <Col lg={9} md={9} sm={9} xs={9}>
              <Container id={this.props.alertResult.id} name={this.props.alertResult.alertName}>
                <Row>
                  <Col>
                    <strong>{translations[this.props.language].sent}:</strong>&nbsp;{this.props.alertResult.deliveredTimestampFormatted}&nbsp;&nbsp;
                    {
                      this.props.alertResult.deliveryMethodType === 'PHONE' &&
                      <>
                        <span>
                          {mobileIcon}&nbsp;{this.props.alertResult.deliveryTarget}
                        </span>
                        <span className="sr-only">To phone number</span>
                      </>

                    }
                    {
                      this.props.alertResult.deliveryMethodType === 'EMAIL' &&
                      <>
                        <span>
                          {envelopeIconBlack}&nbsp;{this.props.alertResult.deliveryTarget}
                        </span>
                        <span className="sr-only">To email</span>
                      </>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <strong>{translations[this.props.language].alert_nickname}:</strong>&nbsp;{this.props.alertResult.alertName}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <strong>{translations[this.props.language].alert_criteria}:</strong>&nbsp;{this.props.alertResult.combinedCriteria}
                  </Col>
                </Row>
                {
                  this.props.alertResult.countyCode && this.props.alertResult.countyCode !== '' &&
                  <Row>
                  <Col>
                    <strong>{translations[this.props.language].county}:</strong>&nbsp;{this.props.alertResult.countyCode}
                  </Col>
                  </Row>
                }
                { 
                  this.state.showMoreInfo !== true &&
                  <Row>
                    <Button variant="link" onClick={this.handleShowMoreInfo}>{translations[this.props.language].more_info}</Button>
                  </Row>
                }
                { 
                  this.state.showMoreInfo === true &&
                  <>
                   <Row>
                    <Col>
                      &nbsp;
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span style={{borderBottom: '2px solid black'}}><strong>{translations[this.props.language].land_record_matched}</strong></span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <strong>{translations[this.props.language].document_number}:</strong>&nbsp;{this.props.alertResult.documentIdentifer}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <strong>{translations[this.props.language].matched_criteria}:</strong>&nbsp;{this.props.alertResult.incomingEventCombinedCriteria}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <strong>{translations[this.props.language].instrument}:</strong>&nbsp;{this.props.alertResult.documentDescription}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <strong>{translations[this.props.language].original_recorded_date}:</strong>&nbsp;{this.props.alertResult.recordedTimestampFormatted}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <strong>{translations[this.props.language].activity_recorded_date}:</strong>&nbsp;{this.props.alertResult.eventTimestampFormatted}
                    </Col>
                  </Row>
                  </>
                }
              </Container>
            </Col>
          </Row>

        </Container>

      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(AlertHistoryViewRow);